import type { Sale } from '../../lib/api.js';

/// Texto comercial para a fatura: itens ativos, sem depender do número interno da venda.
export function chargeDescriptionOf(sale: Sale): string {
  const items = sale.items
    .filter((item) => !item.cancellation)
    .map((item) => `${item.quantity > 1 ? `${item.quantity} × ` : ''}${item.lineDisplayName}`)
    .join('; ');
  const text = items || `Pagamento de serviços e produtos — ${sale.businessUnitName}`;
  return text.length > 200 ? `${text.slice(0, 197)}...` : text;
}
